import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { mediaQuery } from '../../styles/mixin';
import { Clickable } from '../Clickable';

export const NavContainer = styled.nav`
    width: 17rem;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.bgSecondary};
    padding: 2.5rem 1.75rem;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    margin-left: -1rem;
    ${mediaQuery(
        2,
        css`
            width: 21rem;
            padding: 2.5rem 1.75rem;
            border-radius: 0.5rem;
            margin-left: 0;
        `
    )}
`;

export const LogoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: auto;
    margin-bottom: 3.25rem;
    ${mediaQuery(
        2,
        css`
            margin-bottom: 3.75rem;
        `
    )}
`;

export const StyledLink = styled(Link)`
    width: 8.5rem;
    ${mediaQuery(
        2,
        css`
            width: 13.2rem;
        `
    )}
`;

export const NavList = styled.ul`
    display: flex;
    row-gap: 1.5em;
    flex-direction: column;
`;

export const CloseContainer = styled(Clickable)`
    width: 1.25rem;
    height: 1.25rem;
    ${mediaQuery(
        2,
        css`
            display: none;
        `
    )}

    svg {
        fill: ${({ theme }) => theme.colors.bgPrimary};
    }
`;
